import React from 'react';
import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';
import { Stack, Typography } from '@mui/material';

const AdminPublicLayout: React.FC = () => {
  return (
    <Box
      sx={{
        backgroundColor: '#ccc',
        height: '100vh',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Stack direction="column" gap={5}>
        <Typography variant="h4" textAlign="center" fontSize={4}>
          Auction Management
        </Typography>
        <Outlet />
        <Typography variant="body2" textAlign="center" fontStyle="italic" color="text.secondary">
          copyright © 2025 Auction Management
        </Typography>
      </Stack>
    </Box>
  );
};

export default AdminPublicLayout;
